export default "__VITE_ASSET__f9915091__"